// Based off playground/src/ui-components/Image.tsx
import React from 'react'

import styled from 'styled-components'
import {
  HeightProps,
  MaxHeightProps,
  MaxWidthProps,
  MinHeightProps,
  MinWidthProps,
  SpaceProps,
  WidthProps,
  height,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  space,
  width,
} from 'styled-system'

type Props = HeightProps &
  MaxHeightProps &
  MaxWidthProps &
  MinHeightProps &
  MinWidthProps &
  SpaceProps &
  WidthProps

const Image = styled.img<Props>`
  display: block;
  max-width: 100%;

  ${height};
  ${maxHeight};
  ${maxWidth};
  ${minHeight};
  ${minWidth};
  ${space};
  ${width};
`

Image.displayName = 'Image'

Image.defaultProps = {
  height: 'auto',
}

export default React.memo(Image)
